import { unit } from '../../../models/response/y-te/unit';

export enum eUnitActionTypeIds {
	LOAD_START = "UNIT_LOAD_START",
	LOAD_SUCCESS = "UNIT_LOAD_SUCCESS",
	LOAD_ERROR = "UNIT_LOAD_ERROR",

	LOAD_DETAIL_START = "UNIT_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "UNIT_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "UNIT_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "UNIT_SHOW_DETAIL",
	CLOSE_DETAIL = "UNIT_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "UNIT_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "UNIT_SHOW_CONFIRM",
	CLOSE_CONFIRM = "UNIT_CLOSE_CONFIRM",

	SAVE_START = "UNIT_SAVE_START",
	SAVE_SUCCESS = "UNIT_SAVE_SUCCESS",
	SAVE_ERROR = "UNIT_SAVE_ERROR",

	DELETE_START = "UNIT_DELETE_START",
	DELETE_SUCCESS = "UNIT_DELETE_SUCCESS",
	DELETE_ERROR = "UNIT_DELETE_ERROR"
}

export interface IUnitLoadStart {
	type: eUnitActionTypeIds.LOAD_START
}
export interface IUnitLoadSuccess {
	type: eUnitActionTypeIds.LOAD_SUCCESS,
	payload: unit[]
}
export interface IUnitLoadErr {
	type: eUnitActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IUnitLoadDetailStart {
	type: eUnitActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface IUnitLoadDetailSuccess {
	type: eUnitActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: unit
}
export interface IUnitLoadDetailErr {
	type: eUnitActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IUnitShowDetail {
	type: eUnitActionTypeIds.SHOW_DETAIL,
	payload?: unit
}
export interface IUnitCloseDetail {
	type: eUnitActionTypeIds.CLOSE_DETAIL
}
export interface IUnitChangeSelectedIds {
	type: eUnitActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IUnitShowConfirm {
	type: eUnitActionTypeIds.SHOW_CONFIRM
}
export interface IUnitCloseConfirm {
	type: eUnitActionTypeIds.CLOSE_CONFIRM
}
export interface IUnitSaveStart {
	type: eUnitActionTypeIds.SAVE_START,
	payload: unit
}
export interface IUnitSaveSuccess {
	type: eUnitActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IUnitSaveErr {
	type: eUnitActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IUnitDeleteStart {
	type: eUnitActionTypeIds.DELETE_START,
	payload: number
}
export interface IUnitDeleteSuccess {
	type: eUnitActionTypeIds.DELETE_SUCCESS
}
export interface IUnitDeleteErr {
	type: eUnitActionTypeIds.DELETE_ERROR,
	payload: string
}

export type IUnitActionTypes = IUnitLoadStart | IUnitLoadSuccess | IUnitLoadErr |
	IUnitLoadDetailStart | IUnitLoadDetailSuccess | IUnitLoadDetailErr |
	IUnitShowDetail | IUnitCloseDetail |
	IUnitChangeSelectedIds |
	IUnitShowConfirm | IUnitCloseConfirm |
	IUnitSaveStart | IUnitSaveSuccess | IUnitSaveErr |
	IUnitDeleteStart | IUnitDeleteSuccess | IUnitDeleteErr
